import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Button from "components/CustomButtons/Button.js";

// @material-ui/icons
import Close from "@material-ui/icons/Close";

import {
  TitleModalStyled,
  SubtitleModalStyled, 
} from "./styles";

import styles from "assets/jss/material-dashboard-pro-react/modalStyle.js";
import { BLUE_RGB } from "utils/colorsTheme";

const useStyles = makeStyles(styles);

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const GenericModalText = ({
  title = "Modal",
  subtitle = "",
  typeModal = "",
  isOpen,
 children,
  onCloseModal = () => {},
}) => {
  const classes = useStyles();
  return (
    <>
      <Dialog
        classes={{
          root: classes.center,
          paper: classes.modal,
        }}
        open={isOpen}
        transition={Transition}
        keepMounted
        onClose={() => onCloseModal(typeModal)}
        aria-labelledby="modal-slide-title"
        aria-describedby="modal-slide-description"
      >
        <DialogTitle
          id="classic-modal-slide-title"
          disableTypography
          className={classes.modalHeader}
        >
          <Button
            justIcon
            className={classes.modalCloseButton}
            key="close"
            aria-label="Close"
            color="transparent"
            onClick={() => onCloseModal(typeModal)}
          >
            <Close className={classes.modalClose} />
          </Button>
          <TitleModalStyled color={BLUE_RGB} className={classes.modalTitle}>
            {title}
          </TitleModalStyled>
          <SubtitleModalStyled>{subtitle}</SubtitleModalStyled>
        </DialogTitle>
        <DialogContent
          id="modal-slide-description"
          className={classes.modalBody}
        >
         {children}
        </DialogContent>
     
      </Dialog>
    </>
  );
};

export default GenericModalText;
